import $axios from "../../api";

// MODULE NAME
const PREFIX = "/website/discussion";

const state = () => ({
    isLoading: false,
    isErrors: "",
    page: 1,
    isSuccess: false,
    list: null,
    detail: null,
});

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    ASSIGN_ERRORS(state, payload) {
        state.isErrors = payload;
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    SET_IS_SUCCESS(state, payload) {
        state.isSuccess = payload;
    },
    SET_LIST(state, payload) {
        state.list = payload;
    },
    SET_DETAIL(state, payload) {
        state.detail = payload;
    },
};

const actions = {
    getList({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(`${PREFIX}/list`, {
                    params: {
                        view: rootState.Main.view,
                        page: state.page,
                        ...payload,
                    },
                })
                .then((res) => {
                    commit("SET_LIST", res.data.data);
                    commit("SET_LOADING", false);
                    resolve();
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });

                    reject(error);
                });
        });
    },
    getDetail({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(`${PREFIX}/view`, {
                    params: {
                        id: payload,
                    },
                })
                .then((res) => {
                    commit("SET_DETAIL", res.data.data);
                    commit("SET_LOADING", false);
                    resolve();
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });

                    reject(error);
                });
        });
    },
    createReply({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        commit("SET_IS_SUCCESS", false);
        return new Promise((resolve, reject) => {
            $axios
                .post(`${PREFIX}/reply`, payload)
                .then((res) => {
                    commit("SET_IS_SUCCESS", true);
                    commit("SET_LOADING", false);
                    resolve();
                })
                .catch((error) => {
                    commit("ASSIGN_ERRORS", error.response.data.errors);
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                    reject(error);  
                });
        });
    },
    skipDiscussion({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        commit("SET_IS_SUCCESS", false);
        return new Promise((resolve, reject) => {
            $axios
                .put(`${PREFIX}/skip`, payload)
                .then((res) => {
                    commit("SET_IS_SUCCESS", true);
                    commit("SET_LOADING", false);
                    resolve();
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                    reject(error);
                });
        });
    },
    delete({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        commit("SET_IS_SUCCESS", false);
        return new Promise((resolve, reject) => {
            $axios
                .delete(`${PREFIX}/delete-reply`, {
                    data: { review_id: payload },
                })
                .then((res) => {
                    commit("SET_IS_SUCCESS", true);
                    commit("SET_LOADING", false);
                    resolve();
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
